import {Collapse, Row} from "antd";
import React, {useState} from "react";
import {PlusOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {AssignUserGroupButton} from "./AssignedUserGroupsTabStyles";
import UserGroupAssignModal from "./userGroupAssignModal/UserGroupAssignModal";
import {compareString, getLocaleLang} from "../../../../../../utils/helpers";
import {PermissionPolicyList} from "../../permissionPolicyList/PermissionPolicyList";
import {UnassignUserGroupButton} from "./unassignUserGroupButton/UnassignUserGroupButton";

export const AssignedUserGroupsTab = ({
    userId,
    userGroups = [],
    loading = false,
    csrSearchText = "",
    recall = () => {}
}) => {
    const {t, i18n} = useTranslation(["userAuthorization"]);
    const [userGroupAssignModalVisibility, setUserGroupAssignModalVisibility] = useState(false);

    const csrSearchFilter = (data, searchText) =>
        data && Array.isArray(data)
            ? data.filter(
                  userGroup =>
                      compareString(userGroup.name[getLocaleLang(i18n)], searchText) ||
                      compareString(userGroup.key, searchText)
              )
            : [];

    return (
        <>
            <UserGroupAssignModal
                userId={userId}
                visibility={userGroupAssignModalVisibility}
                assignedUserGroups={userGroups}
                onSuccess={() => {
                    setUserGroupAssignModalVisibility(false);
                    recall();
                }}
                onCancel={() => setUserGroupAssignModalVisibility(false)}
            />
            <Row type="flex" justify="end">
                <AssignUserGroupButton
                    icon={<PlusOutlined />}
                    data-testid="assignUserGroupButton"
                    onClick={() => setUserGroupAssignModalVisibility(true)}
                >
                    {t("components.assignUserGroupButton.label", {ns: "userAuthorization"})}
                </AssignUserGroupButton>
            </Row>
            <Collapse accordion={true}>
                {csrSearchFilter(userGroups, csrSearchText).map(userGroup => {
                    const permissionPolicies = userGroup.permissionPolicies;
                    return (
                        <Collapse.Panel
                            header={`${userGroup.name[getLocaleLang(i18n)]}`}
                            key={userGroup._id}
                            showArrow={false}
                            extra={
                                <UnassignUserGroupButton
                                    userId={userId}
                                    userGroupKey={userGroup?.key}
                                    recall={recall}
                                />
                            }
                        >
                            <PermissionPolicyList permissionPolicies={permissionPolicies || []} />
                        </Collapse.Panel>
                    );
                })}
            </Collapse>
        </>
    );
};
